const trim = (value, length) => value == null ? null : String(value).slice(0, length);

// These are question records, not AI-generated links. Keep the student's identity
// with each record: two students can pick different answers to the same question.
export const questionKey = item => JSON.stringify([item.record, item.student || null]);

export function questionEvidence(q, student) {
  if (!q?.recordID || !q.questionText || q.correct == null || typeof q.correct === 'boolean') return null;
  const instruction = q.question || q.raw?.question;
  return {
    record: String(q.recordID), student: student?.userId, name: student?.name,
    skill: trim(q.bandSkillId || q.concept || q.skill?.label, 100),
    text: trim(q.questionText, 1200), instruction: trim(instruction, 250),
    choices: (q.choices || []).slice(0, 5).map(c => ({ letter: c.letter, text: trim(c.text, 200) })),
    picked: trim(q.picked, 120), correct: trim(q.correct, 120),
    whyWrong: trim(q.pickedExplanation, 300), explanation: trim(q.explanation, 350),
    contextComplete: !q.figure && !q.raw?.figure && !(q.choices || []).some(c => c.figure)
      && String(q.questionText).length <= 1200 && String(instruction || '').length <= 250
      && (q.choices || []).every(c => String(c.text || '').length <= 200),
    // Class-wide choice counts must never be attributed to a named student.
    ...(!student ? { choiceCounts: q.choiceCounts, missedBy: typeof q.missedBy === 'number' ? q.missedBy : undefined } : {}),
  };
}
